"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GRAPHQL_RDS_GATEWAY_BASE_URL = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _utils = require("cornerstone_ui_core/lib/utils");

var _constants = require("../constants");

var _baseLayout = require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.helpers");

var _createWorkflowAppolloClient = _interopRequireDefault(require("../utils/createWorkflowAppolloClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        query logUiInfo($Input: UILogVO) {\n          logUiInfo(input: $Input)\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

//TODO Change this to apollo_gateway once its ready
var GRAPHQL_RDS_GATEWAY_BASE_URL = process.env.NODE_ENV === "production" ? "/gateway_rds" + _constants.servicegraphql : _constants.servicebasepath + "/gateway_rds" + _constants.servicegraphql;
exports.GRAPHQL_RDS_GATEWAY_BASE_URL = GRAPHQL_RDS_GATEWAY_BASE_URL;
var appId = localStorage.getItem("AppId");
var client = (0, _createWorkflowAppolloClient.default)(GRAPHQL_RDS_GATEWAY_BASE_URL, {
  appName: appId ? appId : "RDS"
});

var logtoKibana = function logtoKibana(message, messageType) {
  var req = {
    appName: localStorage.getItem("AppId"),
    path: window.location.href,
    message: message,
    messageType: messageType
  };
  return client.query({
    query: (0, _graphqlTag.default)(_templateObject()),
    variables: {
      Input: req
    }
  }).then(function (_ref) {
    var data = _ref.data;

    if (data && data.errors && data.errors.length > 0 && data.errors[0].extensions && data.errors[0].extensions.exception && data.errors[0].extensions.exception.status === 401) {
      (0, _baseLayout.logout)();
    }

    return data.logUiInfo;
  }).catch(_utils.errorHandler);
};

var _default = logtoKibana;
exports.default = _default;